import { USER_ACTION_TYPE } from "../../../types";
import {
  buttonsText,
  errorMessage,
  labels,
  placeholder,
} from "../../../utils/constants";
import { useForm, FormProvider } from "react-hook-form";
import { apiConstants } from "../../../utils/apiConstants";
import { EMAIL_VALIDATION, SUPPLIER_NAME_VALIDATION } from "../../../lib/input/validation-rules";
import { supplierFormData } from "../../../data/formData";
import { preConfigDeptData } from "../../../data/data";
import { useEffect, useRef, useState } from "react";
import { showToast } from "../../../utils";
import UserSnap from "../../../global/ui/UserSnap";
import VerifyPassword from "../../../components/modal/VerifyPassword";
import VerifyUpdatedEmail from "../../../components/modal/VerifyUpdatedEmail";
import RegisterLayout from "../crewProfileSetup/RegisterLayout";
import InputFieldV2 from "../../../lib/input/InputFieldV2";
import DropDownV2 from "../../../global/ui/DropDownV2";

interface basicInfoV2 {
  userData: any;
  onSubmit: (value: any) => void;
  actionType?: any;
  editedSuccessfully?: boolean;
  setEditedSuccessfully: () => void;
}
const BasicInfoV2 = (props: basicInfoV2) => {

  const { ...methods } = useForm({
    mode: 'all',
    defaultValues: { ...supplierFormData(props?.userData) },
    reValidateMode: 'onBlur',
  });

  const [selectedDept, setSelectedDept] = useState([]);
  const [password, setPassword] = useState('');
  const [showPwdPopUp, setShowPwdPopUp] = useState(false);
  const [emailVerifyPopup, setEmailVerifyPopup] = useState(false);
  const [fieldData, setFieldData] = useState({})
  const [updatedField, setUpdatedField] = useState(false)
  const inputRef = useRef<HTMLTextAreaElement>(null);

  const verifyPwd = (data: any) => {
    const pwdData = { ...fieldData, 'password': data.password }
    onSubmit(pwdData)
    setShowPwdPopUp(false);
    setFieldData({});
    setPassword('');
  }
  useEffect(() => {
    if (props.editedSuccessfully && updatedField) {
      setEmailVerifyPopup(true);
    }
  }, [props.editedSuccessfully])
  useEffect(() => {
    methods.setValue(apiConstants.company_logo, props.userData?.supplier_profile?.company_logo, { shouldValidate: true })
  }, [props?.userData]);
  const onSubmit = (values: any) => {
    props.setEditedSuccessfully();
    const apiPayload = { ...values };
    if (selectedDept?.length <= 0) {
      showToast(errorMessage.dept_error, 'error', 'dep');
      return
    }
    const tempSelDepartment = selectedDept.map((item: any) => item.label);
    apiPayload[apiConstants.departments] = tempSelDepartment;
    if (methods.getValues(apiConstants.company_logo) == props.userData?.supplier_profile?.company_logo) {
      delete apiPayload[apiConstants.company_logo]
    }
    if (apiPayload[apiConstants.email] == props?.userData?.[apiConstants.email]) {
      delete apiPayload[apiConstants.email]
    }
    else if (props?.actionType === 'update' && Object.keys(fieldData).length === 0) {
      setFieldData(apiPayload as never);
      setShowPwdPopUp(true);
      setUpdatedField(true);
      return;
    }
    props.onSubmit(apiPayload)
  }

  useEffect(() => {
    if (props?.userData?.supplier_profile?.departments?.length > 0) {
      const tempDept = preConfigDeptData.filter(item => props?.userData?.supplier_profile?.departments?.includes(item.label))
      setSelectedDept(tempDept as never);
    }
  }, [JSON.stringify(props?.userData)])

  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const cursorPosition = e.target.selectionStart;
    const previousScrollPosition = inputRef.current?.scrollTop;
    methods.setValue(apiConstants.bio, e.target.value, { shouldValidate: true });

    requestAnimationFrame(() => {
      e.target.selectionStart = cursorPosition;
      e.target.selectionEnd = cursorPosition;
      if (inputRef.current && previousScrollPosition !== undefined) {
        inputRef.current.scrollTop = previousScrollPosition;
      }
    });
  };
  return (
    <RegisterLayout showLogout hideHeader>
      <FormProvider {...methods} >
        <form action="" onSubmit={methods.handleSubmit(onSubmit)} noValidate>
          <div className="register-step">
            <div className="register-step__heading-block">
              <h1 className="register-step__title">Your Details</h1>
              <p className="register-step__description">
                The more you tell us about yourself the more comprehensive your profile will look.
              </p>
            </div>
            <div className="personal-info__form">
              <div className="text-center">
                <UserSnap
                  onChange={(value) => methods.setValue(apiConstants.company_logo, value, { shouldValidate: true })}
                  value={methods.getValues(apiConstants.company_logo)}
                  label={labels.addLogo}
                />
              </div>

              <div className='col-md-12 mt-4 pt-4'>
                {props.actionType === 'update' ?
                  <div className="personal-info__field">
                    <label className="personal-info__label">{labels.email}</label>
                    <InputFieldV2
                      placeholder={placeholder.email}
                      name={apiConstants.email}
                      type='text'
                      rules={EMAIL_VALIDATION}
                    />
                  </div>
                  : ""}
                <div className="personal-info__field">
                  <label className="personal-info__label">{labels.supplierName}</label>
                  <InputFieldV2
                    placeholder={placeholder.supplierName}
                    name={apiConstants.company_name}
                    type='text'
                    rules={SUPPLIER_NAME_VALIDATION(labels.supplierName)}
                  />
                </div>

              </div>
              <div className="personal-info__field">
                <label className="personal-info__label">{labels.departmentServing}</label>
                <DropDownV2
                  isMultiSelect={true}
                  isClearable={false}
                  data={preConfigDeptData}
                  onSelect={(el) => setSelectedDept(el)}
                  selectedItems={selectedDept}
                  placeholder={placeholder.departmentSelect}
                />
              </div>
              <div className="about__bio-field">
                <label className="about__label">{labels.supplierBio}</label>
                <InputFieldV2
                  name={apiConstants.bio}
                  id="supplier_bio"
                  placeholder={placeholder.shortBio}
                  ref={inputRef}
                  isTextArea
                />
              </div>
            </div>
            <div className="register-step__footer">
              <button
                className="btn-next btn-next--yellow"
                type="submit"
              >
                {props?.actionType === USER_ACTION_TYPE.TYPE_UPDATE ? buttonsText.saveAndUpdate : buttonsText.continue}
              </button>
            </div>
            <VerifyPassword
              pwd={password}
              show={showPwdPopUp}
              closePopup={() => {
                setShowPwdPopUp(false);
                props.setEditedSuccessfully()
              }}
              onSubmit={verifyPwd}
            />
            <VerifyUpdatedEmail
              show={emailVerifyPopup}
              closePopup={() => {
                setEmailVerifyPopup(false);
                props.setEditedSuccessfully()
              }}
            />
          </div>
        </form>
      </FormProvider>
    </RegisterLayout>
  );
};
export default BasicInfoV2;
